import Vue from "vue";

const data = Vue.observable({
  data: {
    profile: {},
    newProfile: {},
    requires: [
      'firstNameLocal', 'lastNameLocal', 'prefixId', 'code'
      , 'facultyId', 'curriculumId', 'telephone', 'email'
    ],
    warning: [],
  }
});

export { data as default };

export const mock = {};
